/**
 * FE SSOT for platform B2C SEO defaults (static index.html + SeoMetaGuard fallback).
 * Values come from Vite env at build time; runtime uses the baked import.meta.env.
 */

const B2B_MARKER_RE = /מערכת\s+סוכני|סוכני\s+נסיעות|travel\s+agent|agency\s+system|booking\s+platform/i;

export const DEFAULT_B2C_SEO = Object.freeze({
  title: "✈️ חופשות בארץ ובעולם במחירים משתלמים",
  description:
    "מלונות, חבילות נופש וטיסות במחירים מעולים עם הזמנה אונליין פשוטה ובטוחה.",
  ogImage: "https://hotelsriver.com/assets/hotelsriver-og-marketing.jpg",
});

function firstNonEmpty(...values) {
  for (const value of values) {
    if (value == null) continue;
    const text = String(value).trim();
    if (text) return text;
  }
  return null;
}

function isConsumerSafeText(text) {
  if (!text) return false;
  return !B2B_MARKER_RE.test(text);
}

/**
 * @param {Record<string, string|undefined>} [env] process.env or import.meta.env
 */
export function resolvePublicB2cSeoDefaults(env = import.meta.env) {
  const title = firstNonEmpty(
    env?.VITE_PUBLIC_B2C_SEO_DEFAULT_TITLE,
    DEFAULT_B2C_SEO.title
  );
  const description = firstNonEmpty(
    env?.VITE_PUBLIC_B2C_SEO_DEFAULT_DESCRIPTION,
    DEFAULT_B2C_SEO.description
  );
  const ogImage = firstNonEmpty(
    env?.VITE_PUBLIC_B2C_SEO_DEFAULT_OG_IMAGE,
    DEFAULT_B2C_SEO.ogImage
  );
  return {
    title: isConsumerSafeText(title) ? title : DEFAULT_B2C_SEO.title,
    description: isConsumerSafeText(description)
      ? description
      : DEFAULT_B2C_SEO.description,
    ogImage,
  };
}

function escapeHtmlAttr(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;");
}

/**
 * Build static <head> SEO block for index.html (build-time injection).
 * @param {{ title: string, description: string, ogImage: string }} defaults
 */
export function buildPublicB2cSeoHeadHtml(defaults) {
  const title = escapeHtmlAttr(defaults.title);
  const description = escapeHtmlAttr(defaults.description);
  const ogImage = escapeHtmlAttr(defaults.ogImage);
  return `<!-- @hr-b2c-seo-start -->
    <title>${title}</title>
    <meta name="description" content="${description}" />
    <meta property="og:title" content="${title}" />
    <meta property="og:description" content="${description}" />
    <meta property="og:image" content="${ogImage}" />
    <meta property="og:type" content="website" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="${title}" />
    <meta name="twitter:description" content="${description}" />
    <meta name="twitter:image" content="${ogImage}" />
    <!-- @hr-b2c-seo-end -->`;
}

export const B2B_SEO_MARKERS = [
  "מערכת סוכני נסיעות",
  "סוכני נסיעות",
  "מערכת סוכני",
];
